var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.092,
    height: 18.092,
    viewBox: "0 0 18.092 18.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#91919c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M59.014,11.546c.015-.215.032-.428.032-.646a8.4,8.4,0,0,0-8.4-8.4c-.217,0-.43.017-.646.032v9.014Z",
    transform: "translate(-40.954 -2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.253,18.474V9.46A8.393,8.393,0,0,0,2.5,17.826c0,.219.017.432.032.647a8.391,8.391,0,0,0,7.72,7.72c.215.015.428.032.647.032a8.393,8.393,0,0,0,8.366-7.753Z",
    transform: "translate(-2.5 -8.135)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetric);
export default __webpack_public_path__ + "static/media/metric.dbf727f7b440e045d5f7bd549ba7021c.svg";
export { ForwardRef as ReactComponent };